import {
  AccordionDetails,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import CustomExpandMore from "../../../../../common/CustomExpandMore";
import { useStyles } from "./styles";
import RemoveIcon from "@mui/icons-material/Remove";
import useStudent from "../../../../../Hooks/student";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import useCourse from "../../../../../Hooks/course";
import { scrolltoView } from "../../../../../Utils/scrollToView";
import useAuthStore from "../../../../../Hooks/auth";

export const educationInformationSchema = Yup.object().shape({
  type: Yup.string().required("* Please select type"),
  collegeOrSchool: Yup.string().required("* Please enter college or school"),
  aggregate: Yup.string().required("* Please enter aggregate"),
  universityOrBboard: Yup.string().required(
    "* Please enter universityOrBboard "
  ),
  year: Yup.string().required("* Please enter year"),
  address: Yup.string().required("* Please enter address"),
  course: Yup.string().required("* Please select course"),
});

const EducationInformation = (props) => {
  const { currentIndex, educationRef } = props;
  const location = useLocation();
  const {institutionId}=useAuthStore();

  const classes = useStyles();
  const {
    removeEducationAction,
    studentPersonalInfo,
    updateEductionInfoItemDataAction,
    educationInformation,
    studentEducationAction,
    profileCompleteness,
    studentDetails,
    deleteEduAction,
  } = useStudent();
  const { departmentData, courseData, getAllCourseAction } = useCourse();
  React.useEffect(() => {
    // const form = document?.querySelector(`.${props.id}`).submit();
    // //console.log("form", form);
  }, []);

  React.useEffect(() => {
    getAllCourseAction({
      course: {
        limit: 100,
        offSet: 0,
        institutionId
      },
    });
  }, []);

  React.useEffect(() => {
    if (educationRef?.current) {
      const { setFieldValue } = educationRef.current;
      if (location?.state?.name) {
        setFieldValue("course", location.state.name);
      }
    }
  }, []);

  const addStudentEducation = {
    type: educationInformation[currentIndex].type || "",
    course: educationInformation[currentIndex].course || "",
    year: educationInformation[currentIndex].year || "",
    aggregate: educationInformation[currentIndex].aggregate || "",
    address: educationInformation[currentIndex].address || "",
    universityOrBboard:
      educationInformation[currentIndex].universityOrBboard || "",
    collegeOrSchool: educationInformation[currentIndex].collegeOrSchool || "",
    id: educationInformation[currentIndex].id || "",
    idStudent:
      educationInformation && educationInformation[currentIndex]?.idStudent
        ? educationInformation[currentIndex]?.idStudent
        : studentDetails?.id,
  };

  return (
    <Stack
      sx={{
        border: "1px solid #D1D5DB",
        mb: 2,
        borderRadius: "23px",
        "& .MuiInputBase-root": {
          borderRadius: "50px",
          fontFamily: "inter !important",
          minWidth: "250px !important",
        },
      }}
      id={props.id}
    >
      <Stack
        sx={{
          color: "#25D5A1",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Stack
          sx={{
            width: "80px",
            height: "80px",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50px",
          }}
          onClick={() => {
            removeEducationAction({ key: currentIndex });
            deleteEduAction({ id: educationInformation[currentIndex]?.id });
            scrolltoView(`#panel2bh-header`);
          }}
        >
          <RemoveIcon />
        </Stack>
      </Stack>
      <Formik
        validationSchema={educationInformationSchema}
        initialValues={addStudentEducation}
        innerRef={educationRef}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize
        onSubmit={(values) => {}}
      >
        {(formik) => {
          const { errors, touched, handleChange, handleSubmit, values } =
            formik;
          return (
            <>
              <form
                id="addStudentEducation"
                onSubmit={handleSubmit}
                className={props.id}
              >
                <AccordionDetails>
                  <Stack
                    className={classes.universityOrBboard}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="universityOrBboard"
                          name="universityOrBboard"
                          placeholder="Enter university Or Bboard"
                          sx={{
                            width: 235,
                          }}
                          className={
                            errors.universityOrBboard &&
                            touched.universityOrBboard
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "universityOrBboard",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.universityOrBboard}
                        />
                        <ErrorMessage
                          name="universityOrBboard"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="collegeOrSchool"
                          name="collegeOrSchool"
                          placeholder="Enter college Or School"
                          sx={{
                            width: 235,
                          }}
                          className={
                            errors.collegeOrSchool && touched.collegeOrSchool
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "collegeOrSchool",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.collegeOrSchool}
                        />
                        <ErrorMessage
                          name="collegeOrSchool"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack
                    className={classes.aggregate}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    <Stack
                      sx={
                        {
                          // flexDirection: "row",
                          // justifyContent: "space-between",
                          // alignItems: "center",
                          // gap: 4,
                          // mb: 2,
                        }
                      }
                    >
                      <Stack>
                        <TextField
                          id="aggregate"
                          name="aggregate"
                          type="number"
                          placeholder="Enter aggregate"
                          sx={{
                            width: 235,
                          }}
                          className={
                            errors.aggregate && touched.aggregate
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          InputProps={{ inputProps: { min: 1, max: 100 } }}
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "aggregate",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.aggregate}
                        />
                        <ErrorMessage
                          name="aggregate"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="address"
                          name="address"
                          placeholder="Enter address"
                          sx={{
                            width: 230,
                          }}
                          className={
                            errors.address && touched.address
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "address",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.address}
                        />
                        <ErrorMessage
                          name="address"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack
                    className={classes.year}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    <Stack>
                      <TextField
                        id="year"
                        name="year"
                        type="number"
                        placeholder="Enter year"
                        sx={{
                          width: 235,
                        }}
                        className={
                          errors.year && touched.year
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={(e) => {
                          handleChange(e);
                          updateEductionInfoItemDataAction({
                            type: "year",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.year}
                      />
                      <ErrorMessage
                        name="year"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>

                    <Stack
                      className={classes.educationInput}
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <Select
                          id="type"
                          name="type"
                          IconComponent={CustomExpandMore}
                          sx={{
                            width: 235,
                          }}
                          className={
                            errors.type && touched.type
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "type",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.type}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            Education Type
                          </MenuItem>
                          <MenuItem value="Full Time">Full Time</MenuItem>
                          <MenuItem value="Part Time">Part Time</MenuItem>
                          <MenuItem value="Distance Learning">
                            Distance Learning
                          </MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                          {/* {departmentData &&
                            departmentData.map((val, ind) => {
                              return (
                                <MenuItem key={ind} selected value={val.name}>
                                  {val.name}
                                </MenuItem>
                              );
                            })} */}
                        </Select>
                        <ErrorMessage
                          name="type"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack
                    className={classes.address}
                    sx={{
                      flexDirection: "row",
                      justifyContent: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <Select
                          id="course"
                          name="course"
                          disabled={location?.state?.name ? true : false}
                          IconComponent={
                            location?.state?.name ? "" : CustomExpandMore
                          }
                          onChange={(e) => {
                            handleChange(e);
                            updateEductionInfoItemDataAction({
                              type: "course",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.course}
                          sx={{
                            width: 235,
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            <span>Select Course</span>
                          </MenuItem>
                          {courseData &&
                            courseData?.course?.map((value, index) => {
                              return (
                                <MenuItem key={index} value={value.name}>
                                  {value.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                        <ErrorMessage
                          name="course"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                </AccordionDetails>
              </form>
            </>
          );
        }}
      </Formik>
    </Stack>
  );
};

export default EducationInformation;
